<template>
  <div class="w-full flex flex-col items-center">
    <menu-item
      v-for="(item, index) in resultList"
      :item="item"
      :key="index"
      @click="onItemClick(item)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import avatarShader from '@/assets/common/avatar-shader.svg';
import language from '@/assets/common/language.svg';
import feedback from '@/assets/common/feedback.svg';
import storeSettings from '@/assets/common/store-settings.svg';
import account from '@/assets/common/account-icon.svg';
import accountWhite from '@/assets/common/account-icon_w.svg';
import report from '@/assets/common/report.svg';
import tryon from '@/assets/common/tryon.svg';
import mobileScan from '@/assets/common/mobile-scan.svg';
import ScanProcess from '@/modules/scan-process';
import MenuItem from './MenuItem.vue';
import { BODY_AI_SCANNER_PAYLOAD } from '@/views/BodyAI/Chat/messages/constants/index';

export default {
  components: {
    MenuItem,
  },
  props: {
    sortMenu: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('mtmUser', ['companyName']),
    list() {
      return [
        {
          img: avatarShader,
          name: this.$t('homePage.avatar_shader_3d'),
          target: '',
          pageName: 'avatar-shader',
        },
        {
          img: language,
          name: this.$t('homePage.language'),
          target: '',
          pageName: 'language',
        },
        {
          img: feedback,
          name: this.$t('homePage.feedback'),
          target: '',
          pageName: 'feedback',
        },
        {
          img: storeSettings,
          name: this.$t('homePage.store_settings'),
          target: this.companyName,
          pageName: 'mtm-login',
        },
        {
          img: account,
          name: this.$t('homePage.account_settings'),
          target: '',
          pageName: 'user-setting',
        },
        {
          img: accountWhite,
          name: this.$t('homePage.profile'),
          target: '',
          pageName: 'profile',
          goTo: 'HomePage',
        },
        {
          img: report,
          name: this.$t('homePage.body_report'),
          target: '',
          pageName: 'body-report',
          goTo: '',
        },
        {
          img: tryon,
          name: this.$t('homePage.try_on_history'),
          target: '',
          pageName: 'try-on-history',
          goTo: '',
        },
        {
          img: mobileScan,
          name: this.$t('homePage.mobile_scan'),
          target: '',
          pageName: 'mobile-scan',
          goTo: 'MobileScan2/UserProfile',
        },
      ];
    },
    resultList() {
      const resultList = [];
      this.sortMenu.forEach(data => {
        const index = this.list.findIndex(item => item.pageName === data);
        resultList.push(this.list[index]);
      });

      return resultList;
    },
  },
  methods: {
    async onItemClick(item) {
      if (item.goTo) {
        if (item.pageName === 'mobile-scan') {
          try {
            this.$events.startLoading(true);
            await ScanProcess.cancel();
            await ScanProcess.initial(BODY_AI_SCANNER_PAYLOAD);
            this.$events.stopLoading();
            this.$events.goto(item.goTo);
          } catch (err) {
            console.log('init bodyAI scanner err', err);
            this.$events.stopLoading();
          }
        } else {
          this.$events.goto(item.goTo);
        }
        this.$emit('close-menu');
        return;
      }

      this.$emit('menu', item);
    },
  },
};
</script>
